export default "__VITE_ASSET__6002b562__"